<ng-template #nullDefault> <em>N/A</em> </ng-template>

<div class="card">
	<div class="card-body text-primary">
		<h6 class="card-title">
			{{ lead.personalDetails.name }}
		</h6>
		<div class="lead-card-container">
			<div class="lead-card">
				<div>
					<ng-container [ngSwitch]="lead.requestType">
						<ng-container *ngSwitchCase="LeadRequestType.ON_SITE_VISIT">
							<i class="bi bi-gear-fill"></i>
							On-site:
						</ng-container>
						<ng-container *ngSwitchCase="LeadRequestType.CALL">
							<i class="bi bi-telephone-fill"></i>
							Call:
						</ng-container>
						<ng-container *ngSwitchDefault> - </ng-container>
					</ng-container>
					<ng-container *ngIf="lead.onSiteVisitAssessment?.serviceType; else nullDefault">
						<em>{{ lead.onSiteVisitAssessment?.serviceType }}</em>
					</ng-container>
				</div>

				<ng-container *ngIf="lead.personalDetails.installationAddress?.fullAddress">
					<app-link-location [property]="lead.personalDetails.installationAddress" [maxCharacters]="50"></app-link-location>
				</ng-container>

				<ng-container *ngIf="lead.onSiteVisitAssessment?.dateTime?.requestedDate">
					<div>
						<i class="bi bi-calendar-check"></i>
						{{ lead.onSiteVisitAssessment?.dateTime?.requestedDate | ngbDateToDate | date: 'dd/MM/yyyy hh:mm a' }}
					</div>
				</ng-container>
			</div>
			<a class="btn btn-sm btn-primary schedule-btn" (click)="schedule()"> <i class="bi bi-calendar"></i> Schedule</a>
		</div>
	</div>
</div>
